import { createVNode, render } from 'vue';
import FactorySwitchModal from './index.vue';

export interface Factory {
  id: number;
  name: string;
}

export interface FactorySwitchOptions {
  onFactorySelect: (factory: Factory) => void;
}

export function showFactorySwitch(opts: FactorySwitchOptions) {
  const container = document.createElement('div');
  const onClose = () => {
    document.body.removeChild(container);
  };
  const vNode = createVNode(FactorySwitchModal, {
    onClose,
    onSelect: opts.onFactorySelect,
  });
  render(vNode, container);
  const instance = vNode.component;
  document.body.appendChild(container);
  instance.exposed.show();
}
